import OrderTypeDocuments from 'assets/img/iconsProducts/authoritiesDocuments.svg?react'
import OrderTypeDroneIcon from 'assets/img/iconsProducts/drone.svg?react'
import OrderTypeEditingIcon from 'assets/img/iconsProducts/photoEditor.svg?react'
import OrderTypeEnergyCertificate from 'assets/img/iconsProducts/energyCertificate.svg?react'
import OrderTypeFloorPlanIcon from 'assets/img/iconsProducts/floorPlan.svg?react'
import OrderTypePhotoIcon from 'assets/img/iconsProducts/photography.svg?react'
import OrderTypeRenderingIcon from 'assets/img/iconsProducts/rendering3D.svg?react'
import OrderTypeStagingIcon from 'assets/img/iconsProducts/staging.svg?react'
import OrderTypeVideoIcon from 'assets/img/iconsProducts/video.svg?react'
import OrderTypeVirtualTourIcon from 'assets/img/iconsProducts/virtualVisit.svg?react'
import { ProductKind } from 'constants/product'
import { ReactNode } from 'react'

/**
 * This function returns an icon component based on the type of product kind passed as an argument.
 * If the product kind doesn't match any defined cases, it defaults to returning a default photo icon.
 * @param kind - The product kind to determine the icon for.
 * @returns A ReactNode representing the icon component for the given product kind.
 */
export const getProductKindIcon = (kind: ProductKind): ReactNode => {
  switch (kind) {
    case ProductKind.GROUND_PHOTO_PRESTIGE:
    case ProductKind.GROUND_PHOTO:
    case ProductKind.PORTRAIT:
    case ProductKind.MATTERPORT_PHOTO:
      return <OrderTypePhotoIcon width="100%" height="1.6rem" />

    case ProductKind.RESIDENTIAL_STAGING:
    case ProductKind.COMMERCIAL_STAGING:
      return <OrderTypeStagingIcon width="100%" height="1.6rem" />

    case ProductKind.HD:
    case ProductKind.FLOORFY_VIRTUAL_TOUR:
      return <OrderTypeVirtualTourIcon width="100%" height="1.6rem" />

    case ProductKind.PRESTIGE_GROUND_AND_DRONE_VIDEO:
    case ProductKind.STANDARD_GROUND_AND_DRONE_VIDEO:
    case ProductKind.REEL_VIDEO:
    case ProductKind.STANDARD_DRONE_VIDEO:
    case ProductKind.STANDARD_GROUND_VIDEO:
    case ProductKind.SLIDESHOW:
    case ProductKind.TEASER_VIDEO:
      return <OrderTypeVideoIcon width="100%" height="1.6rem" />

    case ProductKind.MOBILE_APPLICATION_FLOOR_PLAN:
    case ProductKind.FLOOR_PLAN_EDITING_2D:
    case ProductKind.FLOOR_PLAN_EDITING_3D:
    case ProductKind.FLOOR_PLAN_CERTIFICATION:
    case ProductKind.MATTERPORT_FLOOR_PLAN_WITHOUT_VISIT:
    case ProductKind.MATTERPORT_FLOOR_PLAN_WITH_VISIT:
      return <OrderTypeFloorPlanIcon width="100%" height="1.6rem" />

    case ProductKind.DRONE_PHOTO:
      return <OrderTypeDroneIcon width="100%" height="1.6rem" />

    case ProductKind.PHOTO:
      return <OrderTypeEditingIcon width="100%" height="1.6rem" />

    case ProductKind.RESIDENTIAL_RENDERING:
    case ProductKind.COMMERCIAL_RENDERING:
    case ProductKind.FLOOR_PLAN_RENDERING_3D:
      return <OrderTypeRenderingIcon width="100%" height="1.6rem" />

    case ProductKind.AUTHORITIES_DOCUMENTS:
      return <OrderTypeDocuments width="100%" height="1.6rem" />

    case ProductKind.ENERGY_CERTIFICATE:
    case ProductKind.ENERGY_CERTIFICATE_OF_NEED:
    case ProductKind.CONSUMPTION_CERTIFICATE:
      return <OrderTypeEnergyCertificate width="100%" height="1.6rem" />

    default:
      return <OrderTypePhotoIcon width="100%" height="1.6rem" />
  }
}
